import LandingAccessControl from "./landingPage";


/**
 * Combine and export the routes defined in the admin module for better organization and easier usage.
 * @constant {Object} landingRouteMap
 */
const landingRouteMap = {
  ...LandingAccessControl,
};
export default landingRouteMap;
